var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicOff = function SvgMicOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 34 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M22.923 7.943a.7.7 0 0 1 .135.98l-12.5 16.5a.7.7 0 1 1-1.116-.845l12.5-16.5a.7.7 0 0 1 .98-.135",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M14.675 10.241a3.33 3.33 0 0 1 2.326-.94c.869 0 1.706.336 2.325.94a3.2 3.2 0 0 1 .973 2.292v3.376a3.2 3.2 0 0 1-.973 2.291c-.62.604-1.456.94-2.325.94a3.33 3.33 0 0 1-2.326-.94 3.2 3.2 0 0 1-.972-2.291v-3.376a3.2 3.2 0 0 1 .972-2.292m2.326.46c-.51 0-.994.197-1.348.543a1.8 1.8 0 0 0-.55 1.289v3.376c0 .48.196.943.55 1.289.354.345.839.542 1.348.542s.994-.197 1.348-.542a1.8 1.8 0 0 0 .55-1.29v-3.375a1.8 1.8 0 0 0-.55-1.29 1.93 1.93 0 0 0-1.348-.542m-6.104 5.36a.7.7 0 0 1 .795.588 5.17 5.17 0 0 0 1.793 3.186A5.46 5.46 0 0 0 17 21.112a5.46 5.46 0 0 0 3.515-1.276 5.17 5.17 0 0 0 1.793-3.186.7.7 0 0 1 1.384.207 6.57 6.57 0 0 1-2.274 4.05 6.84 6.84 0 0 1-3.718 1.57v2.294a.7.7 0 1 1-1.4 0v-2.295a6.84 6.84 0 0 1-3.718-1.57 6.57 6.57 0 0 1-2.274-4.05.7.7 0 0 1 .589-.795",
    clipRule: "evenodd"
  })));
};
export default SvgMicOff;